




















































































import PersonProperty from '@/types/PersonProperty.interface'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import csvhelper from '@/plugins/csvhelper'
export default Vue.extend({
    computed: {
        ...mapGetters(['isApp', 'csvRowData', 'csvImportProgress', 'isMobile'])
    },
    mounted() {
        //  If we're on a mobile device, pop 'disabled' message
        if (this.isMobile()) this.popImportDisabled()
    },
    methods: {
        fileHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Upload .csv File',
                text: `MessageDesk requires that you upload your contacts formatted in a .csv file. Read our <a href="${process.env.VUE_APP_URL_LEARN}/en/articles/4527053-how-to-import-contacts-into-messagedesk" target="_blank">how-to article</a> to learn how to format your existing data into a .csv.`
            })
        },
        googleSheetsLink(): void {
            window.open(
                'https://docs.google.com/spreadsheets/u/1/d/1ZiieD9Lg7H81xuB1iQo8YLibF4Z_ABNWt5zZpYX0iII/copy',
                '_blank'
            )
        },
        importConfirm(): void {
            this.$emit('next')
        },
        csvError(message: string): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'CSV Error',
                icon: 'mdi-alert-circle',
                color: 'red lighten-2',
                text: message
            })
        },
        invalidFileType(fileType: string): void {
            const isExcel =
                fileType ==
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

            if (isExcel) {
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Unsupported File Type',
                    text: `Excel files are currently unsupported. Please save your excel file as as a .csv file. Read our guide on <a href="https://learn.messagedesk.app/en/articles/5002561-how-to-convert-an-excel-file-to-csv" target=${
                        this.isApp ? '_system' : '_blank'
                    }>how to convert an excel file to CSV</a> for more information.`,
                    icon: 'mdi-alert-circle'
                })
            }

            return this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Upload Error',
                text: 'The file selected is not a .csv file',
                icon: 'mdi-alert-circle'
            })
        },
        async onFileSelected(): Promise<void> {
            //  Get the file from the file input field
            const file = this.$refs.csvUpload.files[0]

            //  If the file type is not csv, open error dialog
            if (!/\.csv$/i.test(file.name)) {
                return this.invalidFileType(file.type)
            }

            //  If the file size is greater than 12MB, open error dialog
            if (file.size > 12000000) {
                return this.csvError('The maximum file size for is 12MB')
            }

            //  Parse the csv file
            const csvArray = await csvhelper.toArray(file)

            //  If there isn't at least 1 row in the csv file, open error dialog
            if (csvArray.length < 1) {
                return this.csvError("We couldn't find any data in your csv")
            }

            //  If there's more than 2,500 rows, open error dialog
            if (csvArray.length > 2500) {
                return this.csvError('CSV files must have 2,500 rows or less')
            }

            //  Set the csv file name
            this.$store.commit('csvFileNameSet', file.name)

            //  Set the first row of the csv (for displaying sample data)
            this.$store.commit('csvRowDataSet', csvArray[0])

            //  Set all rows of the csv
            this.$store.commit('csvDataSet', csvArray)
        },
        popImportDisabled(): void {
            //  Create the redirect url
            const url = `${process.env.VUE_APP_URL_BASE}/#/signin`

            //  Pop the dialog
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Desktop Only Feature',
                text: `Importing contacts is only available for desktop users. To login on a desktop device, please visit the <a href="${url}">MessageDesk Website.</a>`
            })
        },
        resetInput(): void {
            //  Reset the CSV inputs
            this.$store.commit('csvReset')

            //  Grab our CSV upload input field
            const input = document.getElementById('csvUpload') as HTMLInputElement

            //  Reset the value on this field
            input.value = ''
        },
        templateDownload(): void {
            //  Open dialog for choosing template fields/headers
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Choose Template Fields',
                icon: 'mdi-cloud-download',
                color: 'primary',
                component: 'csv-export-fields',
                props: {
                    isTemplate: true
                },
                callback: async (selected: PersonProperty[]): Promise<void> => {
                    //  Close this dialog
                    await this.$store.dispatch('dialogClose', 'APP')

                    //  Init headers
                    const headers = {}

                    //  Add persons keys to the headers object
                    selected.forEach((x) => {
                        headers[x.name] = null
                    })

                    //  Export the headers template
                    csvhelper.exportCsv('template.csv', [headers])
                }
            })
        },
        templateHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: '.csv Template',
                text: `Once you download our .csv template, copy and paste your existing data into the appropriate column. Read our <a href="${process.env.VUE_APP_URL_LEARN}/en/articles/4527053-how-to-import-contacts-into-messagedesk" target="_blank">how-to article</a> to learn how to format your existing data into a .csv.`
            })
        }
    },
    watch: {
        csvRowData(value: string): void {
            //  If the value does NOT exist, do nothing
            if (!value) return

            //  Else, a new csv has been set, so re-initialize the mapping form
            this.$store.dispatch('csvInit').then(() => {
                //  Since new bindings have been set with auto-match, lets validate and try to upload
                this.importConfirm()
            })
        }
    }
})
